import React from 'react';
import { Feature, InjectorService } from '@tencent/workbench';
import BaseDrawerEffectFeature from '@framework/workbench/common/feature/base-drawer-effect-feature';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { FormItemName, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';
import { PictureColorFeature } from '../picture-color/picture-color-feature';
import { DEFAULT_REGULATE } from '@src/slide/domain/ui-model/element-modeles/property/image-operation/constant/props-value';
import { NumberInputFrom } from '@tencent/wb-ext-form';
import { handleInputBlurInitAndReset } from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import LabelBtn from '@framework/workbench/drawer/components/label-btn';

@Feature()
export class RegulateFeature extends BaseDrawerEffectFeature {
    public ragulateProps = { ...DEFAULT_REGULATE };
    private pictureColorFeature = InjectorService.get(PictureColorFeature);
    public get ragulateInfo() {
        const regulate = this.getPropertyMenu()?.values?.regulate;
        return regulate ? regulate : DEFAULT_REGULATE;
    }
    public get sharpenSoften() {
        return this.ragulateProps?.sharpenSoften;
    }
    public get brightness() {
        return this.ragulateProps?.brightness;
    }
    public get contrast() {
        return this.ragulateProps?.contrast;
    }

    public constructor() {
        super();
        this.addInitPropsCallback(INPUT_PROPS_CALLBACK_KEY.REGULATE);
    }

    public initPropsCallback = () => {
        this.ragulateProps = { ...this.ragulateInfo };
    };

    public renderReset() {
        return <LabelBtn text={i18n.t('重置')} onClick={() => this.resetClick()} disabled={this.isGif()}/>;
    }

    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.REGULATE)
    public handleRegulateChange(value: number, type: string, from?: NumberInputFrom, dragEnd?: boolean) {
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        this.updateRegulateProps({ value: { [type]: value }, onlyChangeUI, from });
        this.tdwDrawerReportNumberInput(type, { ver6: value }, from, onlyChangeUI);
    }

    private updateRegulateProps = (props) => {
        const { value, onlyChangeUI, onPreview, reportInfo } = props;
        this.pictureColorFeature.clearRecolorCache();
        this.ragulateProps = { ...this.ragulateInfo, ...value };
        this.updateProps(ActionType.REGULATE, value, onlyChangeUI, onPreview, reportInfo);
    };


    private resetClick = (): void => {
        this.updateRegulateProps({ value: { ...DEFAULT_REGULATE }, onlyChangeUI: false, onPreview: false,
            reportInfo: { reportId: FormItemName.PICTURE_FIX_RESET } });
    };
}
